import React, { useState } from 'react';
import { colors } from '../../../colors';
import Checkbox from '../../../components/Checkbox';
import { useEditAreNotificationsEnabledMutation } from '../../../store/services/api';
import { useSelector } from 'react-redux';
import { selectUserId } from '../../../store/slices/user';

const Notification = () => {
  const userId = useSelector(selectUserId);

  const [editAreNotificationsEnabled] =
    useEditAreNotificationsEnabledMutation();
  const [areNotificationsEnabled, setAreNotificationsEnabled] = useState(true);

  const handleAreNotificationsEnabledChange = (value: boolean) => {
    editAreNotificationsEnabled({ userId, areNotificationsEnabled: value });
    setAreNotificationsEnabled(value);
  };

  return (
    <div>
      <p
        style={{
          color: 'white',
          fontWeight: 'bold',
          fontSize: 20,
          marginBottom: 5,
        }}
      >
        Email Notifications
      </p>
      <Checkbox
        label={'I want to receive emails from transactions'}
        value={areNotificationsEnabled}
        handleValueChange={handleAreNotificationsEnabledChange}
        color={colors.orange}
      />
    </div>
  );
};

const AccountSettings = () => {
  return (
    <div style={{ padding: 46, paddingTop: 12 }}>
      <Notification />
    </div>
  );
};

export default AccountSettings;
